/* import __COLOCATED_TEMPLATE__ from './status.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

/**
## Event Timeline Status

A component to be used within the `event-timeline` component.

If passed in a block to the component, that content will take precedence over any passed in content
Example:
<Timeline.status @showGraphicBottomLine={{true}}>
  <p>This content will render in place of any texts and callToAction elements from passed in params</p>
</Timeline.status>

@param {String} primaryText - main description for status
@param {String} secondaryText - secondary description for status
@param {DateTime} occurredAt - when the current status happened
@param {Boolean} showGraphicBottomLine - should be shown when there are events to below the status
@param {String} callToAction.text - text for the call to action if there is one
@param {String} callToAction.href - URL if call to action should be a link (cannot be used with `callToAction.action`)
@param {Action} callToAction.action - action if there is a call to action (cannot be used with `callToAction.href`)

Style dependencies: `dashboard/components/_event-timeline.scss`
*/
let Status = (_dec = classNames('event-timeline__status'), _dec(_class = class Status extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "primaryText", null);
    _defineProperty(this, "secondaryText", null);
    _defineProperty(this, "occurredAt", null);
    _defineProperty(this, "showGraphicBottomLine", false);
    _defineProperty(this, "callToAction", null);
  }
}) || _class);
export { Status as default };